import { createFileRoute } from '@tanstack/react-router';
import ScorecardMonitorDashboard from '../../views/dashboard-scorecard-monitor';

export const Route = createFileRoute('/dashboard/scorecard/monitor')({
  component: ScorecardMonitorDashboard,
});
